import PropTypes from 'prop-types'

export const shippingAddressShape = {
  data: PropTypes.shape({
    address: PropTypes.shape({
      city: PropTypes.string,
      country: PropTypes.string,
      line1: PropTypes.string,
      line2: PropTypes.string,
      postalCode: PropTypes.string,
      state: PropTypes.string
    }),
    name: PropTypes.string,
    phone: PropTypes.string
  }),
  isFetching: PropTypes.bool.isRequired,
  error: PropTypes.string
}

export const orderShape = {
  data: PropTypes.shape({
    email: PropTypes.string,
    orderNumber: PropTypes.string
  }),
  isFetching: PropTypes.bool.isRequired,
  error: PropTypes.string
}



// WEBPACK FOOTER //
// /Users/alextaxiera/source/farmhand-server/client/shop/src/js/shapes/checkout.js